import { Box, Link, Typography } from '@mui/material';
import { ReactNode } from 'react';
import NavLink from '../../components/NavLink';
import { getUser, listenUser } from '../../models/Identity';
import route from '../../Router';
import { ListenerDestructor } from '../../models/Observer';

interface IVersionInfo {
    version: string,
    desc: ReactNode[]
}

export default function VersionView() {
    return <Box>
        <Typography variant="h4">История версий</Typography>

        {versions.map(v => <Box component="p">
            <Typography variant="h5" component={Link} href={'#' + v.version}>#{v.version}</Typography>
            <ul>
                {v.desc.map(d => <li>{d}</li>)}
            </ul>
        </Box>)}
    </Box>;
}

export const versions: IVersionInfo[] = [{
    version: '0.5.250403',
    desc: [
        <>
            <Typography>У <NavLink route={[['page', 'house'], ['id']]}>Домовладения</NavLink> добавлена информация о текущей задолжности по начислениям и <b>Площадь участка</b></Typography>
            <Typography>В <NavLink route={[['page', 'project/periodicService'], ['id']]}>Регулярных услугах</NavLink> добавлен расчет по <b>Площади участка</b></Typography>
        </>
    ]
}, {
    version: '0.5.250327',
    desc: [
        'Добавлена возможность редактирования услуг в заявке'
    ]
}, {
    version: '0.5.250305',
    desc: [
        'Переработан дизайн мобильного приложения'
    ]
}, {
    version: '0.4.250218',
    desc: [
        'Услугам и Тарифам добавлены иконки'
    ]
}, {
    version: '0.3.250131',
    desc: [
        <>Добавлена темизация в <NavLink route={[['page', 'project/project'], ['id']]}>форме редактирования ЖК</NavLink></>
    ]
}, {
    version: '0.2.250123',
    desc: [
        <>Добавлен справочник <NavLink route={[['page', 'project/emploees'], ['id']]}>Сотрудников</NavLink></>
    ]
}, {
    version: '0.2.250122',
    desc: [
        <>Добавлен справочник <NavLink route={[['page', 'project/positions'], ['id']]}>Должностей</NavLink></>
    ]
}, {
    version: '0.1.241226',
    desc: [
        'Добавлено автообновление выпадающих списков для выбора из справочника при изменении справочника'
    ]
}];

var listenNotify: ListenerDestructor;
function notifyVersion() {
    listenNotify?.();

    const storedVersion = localStorage.getItem('appversion');
    const currentVersion = versions[0].version;
    if (storedVersion && (storedVersion !== currentVersion)) {
        if (getUser()?.IsAuthenticated) {
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                    var note = new Notification("Приложение обновлено", {
                        icon: '/favicon.svg',
                        body: 'Новая версия: ' + currentVersion
                    });

                    note.onclick = function () {
                        route.setState([['page', 'version']]);
                    }
                }
            });

            localStorage.setItem('appversion', currentVersion);
        } else {
            listenNotify = listenUser(notifyVersion);
        }
    }
}

notifyVersion();